// Comprehensive airport database with IATA codes
export const AIRPORT_DATABASE = [
  // United States
  { iata: 'ATL', city: 'Atlanta', country: 'United States', label: 'Atlanta (ATL)' },
  { iata: 'LAX', city: 'Los Angeles', country: 'United States', label: 'Los Angeles (LAX)' },
  { iata: 'ORD', city: 'Chicago', country: 'United States', label: 'Chicago - O\'Hare (ORD)' },
  { iata: 'DFW', city: 'Dallas', country: 'United States', label: 'Dallas - Fort Worth (DFW)' },
  { iata: 'DEN', city: 'Denver', country: 'United States', label: 'Denver (DEN)' },
  { iata: 'JFK', city: 'New York', country: 'United States', label: 'New York - JFK (JFK)' },
  { iata: 'LGA', city: 'New York', country: 'United States', label: 'New York - LaGuardia (LGA)' },
  { iata: 'EWR', city: 'Newark', country: 'United States', label: 'Newark/New York (EWR)' },
  { iata: 'SFO', city: 'San Francisco', country: 'United States', label: 'San Francisco (SFO)' },
  { iata: 'SJC', city: 'San Jose', country: 'United States', label: 'San Jose (SJC)' },
  { iata: 'OAK', city: 'Oakland', country: 'United States', label: 'Oakland (OAK)' },
  { iata: 'SEA', city: 'Seattle', country: 'United States', label: 'Seattle (SEA)' },
  { iata: 'LAS', city: 'Las Vegas', country: 'United States', label: 'Las Vegas (LAS)' },
  { iata: 'MCO', city: 'Orlando', country: 'United States', label: 'Orlando (MCO)' },
  { iata: 'MIA', city: 'Miami', country: 'United States', label: 'Miami (MIA)' },
  { iata: 'FLL', city: 'Fort Lauderdale', country: 'United States', label: 'Fort Lauderdale (FLL)' },
  { iata: 'PBI', city: 'West Palm Beach', country: 'United States', label: 'West Palm Beach (PBI)' },
  { iata: 'PHX', city: 'Phoenix', country: 'United States', label: 'Phoenix (PHX)' },
  { iata: 'IAH', city: 'Houston', country: 'United States', label: 'Houston (IAH)' },
  { iata: 'HOU', city: 'Houston', country: 'United States', label: 'Houston - Hobby (HOU)' },
  { iata: 'SAN', city: 'San Diego', country: 'United States', label: 'San Diego (SAN)' },
  { iata: 'MSP', city: 'Minneapolis', country: 'United States', label: 'Minneapolis (MSP)' },
  { iata: 'DTW', city: 'Detroit', country: 'United States', label: 'Detroit (DTW)' },
  { iata: 'PHL', city: 'Philadelphia', country: 'United States', label: 'Philadelphia (PHL)' },
  { iata: 'BOS', city: 'Boston', country: 'United States', label: 'Boston (BOS)' },
  { iata: 'CLT', city: 'Charlotte', country: 'United States', label: 'Charlotte (CLT)' },
  { iata: 'BWI', city: 'Baltimore', country: 'United States', label: 'Baltimore (BWI)' },
  { iata: 'IAD', city: 'Washington DC', country: 'United States', label: 'Washington DC - Dulles (IAD)' },
  { iata: 'DCA', city: 'Washington', country: 'United States', label: 'Washington DC - Reagan (DCA)' },
  { iata: 'PDX', city: 'Portland', country: 'United States', label: 'Portland (PDX)' },
  { iata: 'SLC', city: 'Salt Lake City', country: 'United States', label: 'Salt Lake City (SLC)' },
  { iata: 'TPA', city: 'Tampa', country: 'United States', label: 'Tampa (TPA)' },
  { iata: 'BNA', city: 'Nashville', country: 'United States', label: 'Nashville (BNA)' },
  { iata: 'AUS', city: 'Austin', country: 'United States', label: 'Austin (AUS)' },
  { iata: 'RDU', city: 'Raleigh', country: 'United States', label: 'Raleigh-Durham (RDU)' },
  { iata: 'STL', city: 'St Louis', country: 'United States', label: 'St Louis (STL)' },
  { iata: 'MCI', city: 'Kansas City', country: 'United States', label: 'Kansas City (MCI)' },
  { iata: 'CVG', city: 'Cincinnati', country: 'United States', label: 'Cincinnati (CVG)' },
  { iata: 'CLE', city: 'Cleveland', country: 'United States', label: 'Cleveland (CLE)' },
  { iata: 'PIT', city: 'Pittsburgh', country: 'United States', label: 'Pittsburgh (PIT)' },
  { iata: 'IND', city: 'Indianapolis', country: 'United States', label: 'Indianapolis (IND)' },
  { iata: 'CMH', city: 'Columbus', country: 'United States', label: 'Columbus (CMH)' },
  { iata: 'MKE', city: 'Milwaukee', country: 'United States', label: 'Milwaukee (MKE)' },
  { iata: 'OMA', city: 'Omaha', country: 'United States', label: 'Omaha (OMA)' },
  { iata: 'MSY', city: 'New Orleans', country: 'United States', label: 'New Orleans (MSY)' },
  { iata: 'SAT', city: 'San Antonio', country: 'United States', label: 'San Antonio (SAT)' },
  { iata: 'SMF', city: 'Sacramento', country: 'United States', label: 'Sacramento (SMF)' },
  { iata: 'SNA', city: 'Santa Ana', country: 'United States', label: 'Santa Ana/Orange County (SNA)' },
  { iata: 'BUR', city: 'Burbank', country: 'United States', label: 'Burbank (BUR)' },
  { iata: 'ONT', city: 'Ontario', country: 'United States', label: 'Ontario (ONT)' },
  { iata: 'RNO', city: 'Reno', country: 'United States', label: 'Reno (RNO)' },
  { iata: 'ABQ', city: 'Albuquerque', country: 'United States', label: 'Albuquerque (ABQ)' },
  { iata: 'BDL', city: 'Hartford', country: 'United States', label: 'Hartford (BDL)' },
  { iata: 'JAX', city: 'Jacksonville', country: 'United States', label: 'Jacksonville (JAX)' },
  { iata: 'RSW', city: 'Fort Myers', country: 'United States', label: 'Fort Myers (RSW)' },
  { iata: 'PVD', city: 'Providence', country: 'United States', label: 'Providence (PVD)' },
  { iata: 'BUF', city: 'Buffalo', country: 'United States', label: 'Buffalo (BUF)' },
  { iata: 'ROC', city: 'Rochester', country: 'United States', label: 'Rochester (ROC)' },
  { iata: 'SYR', city: 'Syracuse', country: 'United States', label: 'Syracuse (SYR)' },
  { iata: 'ALB', city: 'Albany', country: 'United States', label: 'Albany (ALB)' },
  { iata: 'HNL', city: 'Honolulu', country: 'United States', label: 'Honolulu (HNL)' },
  { iata: 'OGG', city: 'Maui', country: 'United States', label: 'Maui/Kahului (OGG)' },
  { iata: 'KOA', city: 'Kona', country: 'United States', label: 'Kona (KOA)' },
  { iata: 'LIH', city: 'Kauai', country: 'United States', label: 'Kauai/Lihue (LIH)' },
  { iata: 'ANC', city: 'Anchorage', country: 'United States', label: 'Anchorage (ANC)' },

  // Canada
  { iata: 'YYZ', city: 'Toronto', country: 'Canada', label: 'Toronto (YYZ)' },
  { iata: 'YVR', city: 'Vancouver', country: 'Canada', label: 'Vancouver (YVR)' },
  { iata: 'YUL', city: 'Montreal', country: 'Canada', label: 'Montreal (YUL)' },
  { iata: 'YYC', city: 'Calgary', country: 'Canada', label: 'Calgary (YYC)' },
  { iata: 'YEG', city: 'Edmonton', country: 'Canada', label: 'Edmonton (YEG)' },
  { iata: 'YOW', city: 'Ottawa', country: 'Canada', label: 'Ottawa (YOW)' },

  // Europe
  { iata: 'LHR', city: 'London', country: 'United Kingdom', label: 'London - Heathrow (LHR)' },
  { iata: 'LGW', city: 'London', country: 'United Kingdom', label: 'London - Gatwick (LGW)' },
  { iata: 'LCY', city: 'London', country: 'United Kingdom', label: 'London City (LCY)' },
  { iata: 'STN', city: 'London', country: 'United Kingdom', label: 'London - Stansted (STN)' },
  { iata: 'LTN', city: 'London', country: 'United Kingdom', label: 'London - Luton (LTN)' },
  { iata: 'MAN', city: 'Manchester', country: 'United Kingdom', label: 'Manchester (MAN)' },
  { iata: 'EDI', city: 'Edinburgh', country: 'United Kingdom', label: 'Edinburgh (EDI)' },
  { iata: 'GLA', city: 'Glasgow', country: 'United Kingdom', label: 'Glasgow (GLA)' },
  { iata: 'CDG', city: 'Paris', country: 'France', label: 'Paris - Charles de Gaulle (CDG)' },
  { iata: 'ORY', city: 'Paris', country: 'France', label: 'Paris - Orly (ORY)' },
  { iata: 'NCE', city: 'Nice', country: 'France', label: 'Nice (NCE)' },
  { iata: 'LYS', city: 'Lyon', country: 'France', label: 'Lyon (LYS)' },
  { iata: 'MRS', city: 'Marseille', country: 'France', label: 'Marseille (MRS)' },
  { iata: 'FRA', city: 'Frankfurt', country: 'Germany', label: 'Frankfurt (FRA)' },
  { iata: 'MUC', city: 'Munich', country: 'Germany', label: 'Munich (MUC)' },
  { iata: 'BER', city: 'Berlin', country: 'Germany', label: 'Berlin (BER)' },
  { iata: 'DUS', city: 'Dusseldorf', country: 'Germany', label: 'Dusseldorf (DUS)' },
  { iata: 'HAM', city: 'Hamburg', country: 'Germany', label: 'Hamburg (HAM)' },
  { iata: 'AMS', city: 'Amsterdam', country: 'Netherlands', label: 'Amsterdam (AMS)' },
  { iata: 'MAD', city: 'Madrid', country: 'Spain', label: 'Madrid (MAD)' },
  { iata: 'BCN', city: 'Barcelona', country: 'Spain', label: 'Barcelona (BCN)' },
  { iata: 'AGP', city: 'Malaga', country: 'Spain', label: 'Malaga (AGP)' },
  { iata: 'SVQ', city: 'Seville', country: 'Spain', label: 'Seville (SVQ)' },
  { iata: 'PMI', city: 'Palma', country: 'Spain', label: 'Palma de Mallorca (PMI)' },
  { iata: 'FCO', city: 'Rome', country: 'Italy', label: 'Rome - Fiumicino (FCO)' },
  { iata: 'CIA', city: 'Rome', country: 'Italy', label: 'Rome - Ciampino (CIA)' },
  { iata: 'MXP', city: 'Milan', country: 'Italy', label: 'Milan - Malpensa (MXP)' },
  { iata: 'LIN', city: 'Milan', country: 'Italy', label: 'Milan - Linate (LIN)' },
  { iata: 'VCE', city: 'Venice', country: 'Italy', label: 'Venice (VCE)' },
  { iata: 'NAP', city: 'Naples', country: 'Italy', label: 'Naples (NAP)' },
  { iata: 'FLR', city: 'Florence', country: 'Italy', label: 'Florence (FLR)' },
  { iata: 'BLQ', city: 'Bologna', country: 'Italy', label: 'Bologna (BLQ)' },
  { iata: 'ZRH', city: 'Zurich', country: 'Switzerland', label: 'Zurich (ZRH)' },
  { iata: 'GVA', city: 'Geneva', country: 'Switzerland', label: 'Geneva (GVA)' },
  { iata: 'VIE', city: 'Vienna', country: 'Austria', label: 'Vienna (VIE)' },
  { iata: 'BRU', city: 'Brussels', country: 'Belgium', label: 'Brussels (BRU)' },
  { iata: 'CPH', city: 'Copenhagen', country: 'Denmark', label: 'Copenhagen (CPH)' },
  { iata: 'ARN', city: 'Stockholm', country: 'Sweden', label: 'Stockholm (ARN)' },
  { iata: 'OSL', city: 'Oslo', country: 'Norway', label: 'Oslo (OSL)' },
  { iata: 'HEL', city: 'Helsinki', country: 'Finland', label: 'Helsinki (HEL)' },
  { iata: 'DUB', city: 'Dublin', country: 'Ireland', label: 'Dublin (DUB)' },
  { iata: 'LIS', city: 'Lisbon', country: 'Portugal', label: 'Lisbon (LIS)' },
  { iata: 'OPO', city: 'Porto', country: 'Portugal', label: 'Porto (OPO)' },
  { iata: 'ATH', city: 'Athens', country: 'Greece', label: 'Athens (ATH)' },
  { iata: 'IST', city: 'Istanbul', country: 'Turkey', label: 'Istanbul (IST)' },
  { iata: 'SAW', city: 'Istanbul', country: 'Turkey', label: 'Istanbul - Sabiha Gokcen (SAW)' },
  { iata: 'PRG', city: 'Prague', country: 'Czech Republic', label: 'Prague (PRG)' },
  { iata: 'BUD', city: 'Budapest', country: 'Hungary', label: 'Budapest (BUD)' },
  { iata: 'WAW', city: 'Warsaw', country: 'Poland', label: 'Warsaw (WAW)' },
  { iata: 'KRK', city: 'Krakow', country: 'Poland', label: 'Krakow (KRK)' },

  // Middle East
  { iata: 'DXB', city: 'Dubai', country: 'UAE', label: 'Dubai (DXB)' },
  { iata: 'AUH', city: 'Abu Dhabi', country: 'UAE', label: 'Abu Dhabi (AUH)' },
  { iata: 'DOH', city: 'Doha', country: 'Qatar', label: 'Doha (DOH)' },
  { iata: 'RUH', city: 'Riyadh', country: 'Saudi Arabia', label: 'Riyadh (RUH)' },
  { iata: 'JED', city: 'Jeddah', country: 'Saudi Arabia', label: 'Jeddah (JED)' },
  { iata: 'CAI', city: 'Cairo', country: 'Egypt', label: 'Cairo (CAI)' },
  { iata: 'TLV', city: 'Tel Aviv', country: 'Israel', label: 'Tel Aviv (TLV)' },
  { iata: 'AMM', city: 'Amman', country: 'Jordan', label: 'Amman (AMM)' },

  // Asia
  { iata: 'HND', city: 'Tokyo', country: 'Japan', label: 'Tokyo - Haneda (HND)' },
  { iata: 'NRT', city: 'Tokyo', country: 'Japan', label: 'Tokyo - Narita (NRT)' },
  { iata: 'KIX', city: 'Osaka', country: 'Japan', label: 'Osaka (KIX)' },
  { iata: 'ICN', city: 'Seoul', country: 'South Korea', label: 'Seoul - Incheon (ICN)' },
  { iata: 'GMP', city: 'Seoul', country: 'South Korea', label: 'Seoul - Gimpo (GMP)' },
  { iata: 'HKG', city: 'Hong Kong', country: 'Hong Kong', label: 'Hong Kong (HKG)' },
  { iata: 'SIN', city: 'Singapore', country: 'Singapore', label: 'Singapore (SIN)' },
  { iata: 'BKK', city: 'Bangkok', country: 'Thailand', label: 'Bangkok (BKK)' },
  { iata: 'KUL', city: 'Kuala Lumpur', country: 'Malaysia', label: 'Kuala Lumpur (KUL)' },
  { iata: 'CGK', city: 'Jakarta', country: 'Indonesia', label: 'Jakarta (CGK)' },
  { iata: 'DPS', city: 'Bali', country: 'Indonesia', label: 'Bali/Denpasar (DPS)' },
  { iata: 'MNL', city: 'Manila', country: 'Philippines', label: 'Manila (MNL)' },
  { iata: 'HAN', city: 'Hanoi', country: 'Vietnam', label: 'Hanoi (HAN)' },
  { iata: 'SGN', city: 'Ho Chi Minh City', country: 'Vietnam', label: 'Ho Chi Minh City (SGN)' },
  { iata: 'PEK', city: 'Beijing', country: 'China', label: 'Beijing (PEK)' },
  { iata: 'PVG', city: 'Shanghai', country: 'China', label: 'Shanghai - Pudong (PVG)' },
  { iata: 'CAN', city: 'Guangzhou', country: 'China', label: 'Guangzhou (CAN)' },
  { iata: 'DEL', city: 'Delhi', country: 'India', label: 'Delhi (DEL)' },
  { iata: 'BOM', city: 'Mumbai', country: 'India', label: 'Mumbai (BOM)' },
  { iata: 'BLR', city: 'Bangalore', country: 'India', label: 'Bangalore (BLR)' },

  // Australia & Oceania
  { iata: 'SYD', city: 'Sydney', country: 'Australia', label: 'Sydney (SYD)' },
  { iata: 'MEL', city: 'Melbourne', country: 'Australia', label: 'Melbourne (MEL)' },
  { iata: 'BNE', city: 'Brisbane', country: 'Australia', label: 'Brisbane (BNE)' },
  { iata: 'PER', city: 'Perth', country: 'Australia', label: 'Perth (PER)' },
  { iata: 'ADL', city: 'Adelaide', country: 'Australia', label: 'Adelaide (ADL)' },
  { iata: 'AKL', city: 'Auckland', country: 'New Zealand', label: 'Auckland (AKL)' },
  { iata: 'CHC', city: 'Christchurch', country: 'New Zealand', label: 'Christchurch (CHC)' },

  // Latin America
  { iata: 'MEX', city: 'Mexico City', country: 'Mexico', label: 'Mexico City (MEX)' },
  { iata: 'CUN', city: 'Cancun', country: 'Mexico', label: 'Cancun (CUN)' },
  { iata: 'GDL', city: 'Guadalajara', country: 'Mexico', label: 'Guadalajara (GDL)' },
  { iata: 'MTY', city: 'Monterrey', country: 'Mexico', label: 'Monterrey (MTY)' },
  { iata: 'GRU', city: 'Sao Paulo', country: 'Brazil', label: 'Sao Paulo (GRU)' },
  { iata: 'GIG', city: 'Rio de Janeiro', country: 'Brazil', label: 'Rio de Janeiro (GIG)' },
  { iata: 'BOG', city: 'Bogota', country: 'Colombia', label: 'Bogota (BOG)' },
  { iata: 'LIM', city: 'Lima', country: 'Peru', label: 'Lima (LIM)' },
  { iata: 'SCL', city: 'Santiago', country: 'Chile', label: 'Santiago (SCL)' },
  { iata: 'EZE', city: 'Buenos Aires', country: 'Argentina', label: 'Buenos Aires (EZE)' },

  // Caribbean
  { iata: 'SJU', city: 'San Juan', country: 'Puerto Rico', label: 'San Juan (SJU)' },
  { iata: 'MBJ', city: 'Montego Bay', country: 'Jamaica', label: 'Montego Bay (MBJ)' },
  { iata: 'NAS', city: 'Nassau', country: 'Bahamas', label: 'Nassau (NAS)' },
  { iata: 'PUJ', city: 'Punta Cana', country: 'Dominican Republic', label: 'Punta Cana (PUJ)' },

  // Africa
  { iata: 'NBO', city: 'Nairobi', country: 'Kenya', label: 'Nairobi (NBO)' },
  { iata: 'JNB', city: 'Johannesburg', country: 'South Africa', label: 'Johannesburg (JNB)' },
  { iata: 'CPT', city: 'Cape Town', country: 'South Africa', label: 'Cape Town (CPT)' },
  { iata: 'CAI', city: 'Cairo', country: 'Egypt', label: 'Cairo (CAI)' },
];

// Convert city name or IATA code to standardized IATA code
export function convertToIATA(input) {
  if (!input) return null;

  const searchTerm = input.trim().toUpperCase();

  // Check if it's already a valid IATA code (3 uppercase letters)
  if (/^[A-Z]{3}$/.test(searchTerm)) {
    // Verify it exists in our database
    const airport = AIRPORT_DATABASE.find(a => a.iata === searchTerm);
    if (airport) return searchTerm;
  }

  // Search by city name (case-insensitive)
  const byCity = AIRPORT_DATABASE.find(airport => 
    airport.city.toUpperCase() === searchTerm
  );
  if (byCity) return byCity.iata;

  // Search by partial city name match
  const partialMatch = AIRPORT_DATABASE.find(airport =>
    airport.city.toUpperCase().includes(searchTerm) ||
    searchTerm.includes(airport.city.toUpperCase())
  );
  if (partialMatch) return partialMatch.iata;

  // If no match found, return the original input (user might have typed a valid but unlisted code)
  return input.trim().toUpperCase();
}

// Search airports by query
export function searchAirports(query) {
  if (!query || query.length < 2) return [];

  const searchTerm = query.toUpperCase();

  return AIRPORT_DATABASE.filter(airport =>
    airport.iata.startsWith(searchTerm) ||
    airport.city.toUpperCase().includes(query.toUpperCase()) ||
    airport.country.toUpperCase().includes(query.toUpperCase())
  ).map(airport => ({
    label: airport.label,
    value: airport.iata,
    city: airport.city,
    country: airport.country
  }));
}

